import { Auth } from 'aws-amplify';

const getCurrentUserId = async () => {
  try {
    const user = await Auth.currentUserInfo();
    return user.id;
  } catch (err) {}
  return null;
};

export default getCurrentUserId;
